export const environment = {
  production: false,
  apiGateway: {
    url: "https://api-ha-dev.sc.geappl.io/",
    stage: "Yamazumi"
  },
  AllowScreenAuth: false,  
  cognitoOptionsHA: [
    {
      Region: "us-east-1",
      ClientId: '68h4jq5b3oi4qq02690p6ve3k2', // Your client id here
      AppWebDomain: 'mesauth.auth.us-east-1.amazoncognito.com', // Exclude the "https://" part.
      TokenScopesArray: ['openid', 'profile', 'email'],
      UserPoolId: 'us-east-1_s1pKZcsUG',
      AdvancedSecurityDataCollectionFlag: false
    },
    {
      Region: "us-west-2",
      ClientId: '6f31obccim9tjmo62lvk3cgaou', // Your client id here
      AppWebDomain: 'mesauth.auth.us-west-2.amazoncognito.com', // Exclude the "https://" part.
      TokenScopesArray: ['openid', 'profile', 'email'],
      UserPoolId: 'us-west-2_R29ioKZps',
      AdvancedSecurityDataCollectionFlag: false
    }
  ],
  SSRSUrl: "http://proficy-reports-dev/ReportServer?"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';  // Included with Angular CLI.